import { MantineProvider } from '@mantine/core';
import React, { lazy, Suspense } from 'react';
import { Toaster } from 'react-hot-toast';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { StyleSheetManager, ThemeProvider } from 'styled-components';
import Loader from './components/Loader';
import ProtectedOutlet from './components/Routes/ProtectedOutlet';
import DiagramPublicView from './pages/DiagramPublicView/DiagramPublicView';
import { store } from './redux/store';
import { colorsList } from './styles/colors/brandColors';
import { getColor } from './styles/mixins';
import { lightTheme } from './styles/themes';
const Dashboard = lazy(() => import('./pages/Dashboard'));
const Home = lazy(() => import('./pages/Home'));
const About = lazy(() => import('./pages/About'));
const DiagramEditor = lazy(() => import('./pages/DiagramEditor'));
const Login = lazy(() => import('./pages/Auth'));
const QueryPage = lazy(() => import('./pages/QueryPage'));

const App = () => {
  return (
    <Provider store={store}>
      <MantineProvider
        theme={{ colors: colorsList, fontFamily: 'Poppins, sans-serif' }}
      >
        <StyleSheetManager disableVendorPrefixes>
          <ThemeProvider theme={lightTheme}>
            <Toaster
              position="bottom-right"
              reverseOrder={false}
              toastOptions={{
                duration: 3000,
                style: {
                  background: getColor('gray', 800),
                  color: getColor('gray', 0),
                },
              }}
            />
            <Router>
              <Suspense fallback={<Loader />}>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/auth/login" element={<Login />} />
                  <Route
                    path="/diagrams/public-view/:diagramId"
                    element={<DiagramPublicView />}
                  />
                  <Route path="/dashboard" element={<ProtectedOutlet />}>
                    <Route path="/dashboard" element={<Dashboard />} />
                  </Route>
                  <Route
                    path="/diagrams/editor/:diagramId"
                    element={<ProtectedOutlet />}
                  >
                    <Route
                      path="/diagrams/editor/:diagramId"
                      element={<DiagramEditor />}
                    />
                  </Route>
                  <Route
                    path="/diagrams/query/:diagramId"
                    element={<ProtectedOutlet />}
                  >
                    <Route
                      path="/diagrams/query/:diagramId"
                      element={<QueryPage />}
                    />
                  </Route>
                </Routes>
              </Suspense>
            </Router>
          </ThemeProvider>
        </StyleSheetManager>
      </MantineProvider>
    </Provider>
  );
};

export default App;
